import { render, staticRenderFns } from "./page-footer.vue?vue&type=template&id=65ac5314&scoped=true"
import script from "./page-footer.vue?vue&type=script&lang=js"
export * from "./page-footer.vue?vue&type=script&lang=js"
import style0 from "./page-footer.vue?vue&type=style&index=0&id=65ac5314&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65ac5314",
  null
  
)

export default component.exports